import React, { PureComponent } from 'react';

// Componentes
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';

import ImportAtlasRenderScene from './ImportAtlasRenderScene';

import './ImportAtlasRender.scss';
import { Observer, GLOBAL_EVENT } from '../../../../Observer';
import b64toBlob from '../../../../../../utils/b64toBlob';
import { ImageData } from '../../../../../../Redux/Actions/Atlas/images.action';

interface stateInterface {
    open: boolean;
}

let _scrollBarRefAtlas: any = null;

export class ImportAtlasRender extends PureComponent<{}, stateInterface> {
    game: any;
    componentDidMount() {
        _scrollBarRefAtlas.updateScroll();
        Observer.removeListener(GLOBAL_EVENT.IMPORT_ATLAS.OPEN_ATLAS_IMPORT_SEND_IMAGE);
        Observer.on(
            GLOBAL_EVENT.IMPORT_ATLAS.OPEN_ATLAS_IMPORT_SEND_IMAGE,
            (images: Required<ImageData>[]) => {
                this.game = new Phaser.Game({
                    width: 0,
                    height: 0,
                    parent: 'render-atlas-import',
                    type: Phaser.CANVAS,
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                    banner: {
                        hidePhaser: true,
                    },
                    audio: {
                        noAudio: true,
                    },
                    render: {
                        pixelArt: true,
                    },
                    scene: [ImportAtlasRenderScene],
                });

                /**
                 * Se espera que la escena esté cargada
                 * Una vez esté cargada se obtiene la escena
                 * Envíamos el evento para setear el nombre que usaremos internamente durante el proceso de cortado
                 * Cargamos la imagen e iniciamos el load con start()
                 */
                this.game.registry.events.on(Phaser.Scenes.Events.READY, () => {
                    const scene = (this.game as Phaser.Game).scene.getScene(
                        'ImportAtlasRenderScene'
                    );
                    scene.events.emit('set_name', images[0].name);
                    scene.load.image(images[0].name, URL.createObjectURL(b64toBlob(images[0].src)));
                    scene.load.start();
                });
            }
        );

        Observer.on(GLOBAL_EVENT.IMPORT_ATLAS.CLOSE_ATLAS_IMPORT, () => {
            this.game.destroy(true);
        });
    }

    handleDrag(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        if (!!event.buttons) {
            const scroll = document.querySelector('.scrollContainerAtlas') as HTMLDivElement;
            scroll.scrollLeft = scroll.scrollLeft - event.movementX;
            scroll.scrollTop = scroll.scrollTop - event.movementY;
            _scrollBarRefAtlas.updateScroll();
        }
    }

    render() {
        return (
            <div className="lienzo-render">
                <PerfectScrollbar
                    className="scrollContainerAtlas"
                    ref={(ref) => {
                        _scrollBarRefAtlas = ref;
                    }}
                >
                    <div id="render-atlas-import" onMouseMove={this.handleDrag}></div>
                </PerfectScrollbar>
            </div>
        );
    }
}

export default ImportAtlasRender;
